module.exports = __webpack_public_path__ + "assets/img/sh24.56950645.jpg";